import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const CreateBlogTest = () => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState('');
    const navigate = useNavigate();
    const quillRef = useRef(null);

    const [isVideo, setIsVideo] = useState(false);
    const [isForm, setIsForm] = useState(false);
    const [videoLink, setVideoLink] = useState('');
    const [paymentLink, setPaymentLink] = useState('');
    const [linkName, setLinkName] = useState('');
    const [link, setLink] = useState('');

    const inputStyles = "bg-gray-900 border border-gray-700 text-gray-200 p-3 rounded-lg w-full focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all duration-300 shadow-sm";
    const labelStyles = "block text-gray-300 text-sm font-semibold mb-2";

    useEffect(() => {
        axiosInstance.get('/categories')
            .then(res => setCategories(res.data))
            .catch(err => console.error("Failed to fetch categories", err));
    }, []);

    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            const formData = new FormData();
            formData.append('image', file);
            try {
                const response = await axiosInstance.post('/blogs/upload-image-cloudinary', formData);
                const imageUrl = response.data.url;
                const quill = quillRef.current.getEditor();
                const range = quill.getSelection(true);
                quill.insertEmbed(range.index, 'image', imageUrl);
            } catch (error) {
                console.error('Quill image upload failed', error);
            }
        };
    };

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline'],
                ['link', 'image']
            ],
            handlers: { image: imageHandler },
        },
    }), []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        let finalImageUrl = null;
        let finalPdfUrl = null;

        try {
            if (imageFile) {
                setStatus('Uploading featured image...');
                const imageFormData = new FormData();
                imageFormData.append('image', imageFile);
                const imgRes = await axiosInstance.post('/blogs/upload-image-cloudinary', imageFormData);
                finalImageUrl = imgRes.data.url;
            }

            if (pdfFile) {
                setStatus('Uploading PDF...');
                const pdfFormData = new FormData();
                pdfFormData.append('pdfFile', pdfFile);
                const pdfRes = await axiosInstance.post('/blogs/upload-pdf-local', pdfFormData);
                finalPdfUrl = pdfRes.data.link;
            }

            setStatus('Saving blog post...');
            const blogData = {
                title,
                content,
                category_id: selectedCategory,
                image: finalImageUrl,
                pdf_link: finalPdfUrl,
                isVideo: isVideo,
                video_link: isVideo ? videoLink : null,
                payment_link: paymentLink || null,
                form_name: linkName || null,
                form_link: link || null
            };

            console.log("Data", blogData)
            await axiosInstance.post('/blogs', blogData);
            navigate('/admin/blogs-manage');
        } catch (error) {
            console.error('Failed to create blog:', error);
            setStatus(`Error: ${error.response?.data?.error || 'An unknown error occurred.'}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="max-w-6xl mx-auto p-2">
          
            <form onSubmit={handleSubmit} className="bg-gray-800 p-8 rounded-2xl shadow-xl space-y-6">
                  <h1 className="text-4xl font-bold mb-8 text-gray-100 text-center">Create a Blog</h1>
                {/* Title */}
                <div>
                    <label className={labelStyles}>Title</label>
                    <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className={inputStyles} placeholder="Enter blog title" required />
                </div>

                {/* Category */}
                <div>
                    <label className={labelStyles}>Category</label>
                    <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} className={inputStyles + " bg-gray-900"} required>
                        <option value="" disabled>Select a category</option>
                        {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
                    </select>
                </div>

                {/* Content */}
                <div>
                    <label className={labelStyles}>Content</label>
                    <ReactQuill ref={quillRef} theme="snow" value={content} onChange={setContent} modules={modules} className="bg-gray-900 rounded-lg" />
                </div>

                {/* Featured Image */}
                <div>
                    <label className={labelStyles}>Featured Image</label>
                    <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} className={inputStyles} />
                </div>

                {/* PDF */}
                <div>
                    <label className={labelStyles}>Attach PDF</label>
                    <input type="file" accept=".pdf" onChange={(e) => setPdfFile(e.target.files[0])} className={inputStyles} />
                </div>

                {/* Payment Link */}
                <div>
                    <label className={labelStyles}>Payment Link (Optional)</label>
                    <input type="url" value={paymentLink} onChange={(e) => setPaymentLink(e.target.value)} className={inputStyles} placeholder="https://example.com/payment" />
                </div>

              

                 {/* Video Option */}
                <div className="p-4 border border-gray-700 rounded-lg bg-gray-900">
                    <label className={labelStyles}>Is this a video post?</label>
                    <div className="flex items-center space-x-6 text-gray-200">
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isVideo" checked={isVideo === true} onChange={() => setIsVideo(true)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>Yes</span>
                        </label>
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isVideo" checked={isVideo === false} onChange={() => setIsVideo(false)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>No</span>
                        </label>
                    </div>
                </div>

                {isVideo && (
                    <div className="space-y-4 animate-fade-in">
                        <div>
                            <label className={labelStyles}>Video Link</label>
                            <input type="url" value={videoLink} onChange={(e) => setVideoLink(e.target.value)} className={inputStyles} placeholder="https://example.com/video" required />
                        </div>
                    </div>
                )}


  {/* Link Option */}
                <div className="p-4 border border-gray-700 rounded-lg bg-gray-900">
                    <label className={labelStyles}>Is there a link ?</label>
                    <div className="flex items-center space-x-6 text-gray-200">
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isForm" checked={isForm === true} onChange={() => setIsForm(true)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>Yes</span>
                        </label>
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isForm" checked={isForm === false} onChange={() => setIsForm(false)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>No</span>
                        </label>
                    </div>
                </div>

                {isForm && (
                    <div className="space-y-4 animate-fade-in">
                        <div>
                            <label className={labelStyles}>Name</label>
                            <input type="text" value={linkName} onChange={(e) => setLinkName(e.target.value)} className={inputStyles} placeholder="Name " required />
                        </div>

                         <div>
                            <label className={labelStyles}>Link</label>
                            <input type="url" value={link} onChange={(e) => setLink(e.target.value)} className={inputStyles} placeholder="https://example.com/link" required />
                        </div>

                    </div>
                )}


                <button type="submit" disabled={isLoading} className="w-full py-3 bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-semibold rounded-xl hover:from-indigo-500 hover:to-blue-500 transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed">
                    {isLoading ? status : 'Create Blog Post'}
                </button>

                {isLoading && status && <p className="text-center text-gray-300 mt-2">{status}</p>}
            </form>

            <style>{`
                [contentEditable][data-placeholder]:empty:before {
                  content: attr(data-placeholder);
                  color: #9ca3af; 
                  pointer-events: none;
                  display: block; 
                }
                @keyframes fade-in {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fade-in {
                    animation: fade-in 0.5s ease-out forwards;
                }
            `}</style>
        </div>
    );
};

export default CreateBlogTest;
